import E, { createContext as x, useContext as I, useMemo as T, useEffect as q, useCallback as z } from "react";
import J from "qs";
import { useSnack as A } from "@reapit/elements";
import { useQueryClient as X, useQuery as Y, useMutation as ee } from "@tanstack/react-query";
import k from "axios";
import { useNavigate as N } from "react-router";
import { ReapitConnectBrowserSession as te } from "@reapit/connect-session";
const O = "Missing valid Reapit Connect Session, please try logging in again if the problem persists", P = "ERR_NETWORK", j = async (r, n) => {
  const e = (await r.connectSession())?.accessToken;
  return e ? {
    Authorization: `Bearer ${e}`,
    "api-version": "latest",
    "Content-Type": "application/json",
    ...n
  } : null;
}, B = (r, n) => {
  const s = r?.response?.data, { description: e, title: o, message: i, errors: u } = s ?? {}, d = e || o || i || (r?.message ? r.message : n || "An unknown error has occurred, please refresh the page and try again."), g = Array.isArray(u) ? u?.map(({ field: f, message: h }) => `"${f}: ${h}"`) : null, c = g ? g.join(", ") : "";
  return `${d} ${c}`;
}, re = (r, n) => r.reduce((s, e, o) => o ? `${s}&${n}=${e}` : String(e), ""), ne = (r) => Object.keys(r).reduce((n, s) => {
  const e = r[s];
  return Array.isArray(e) ? n[s] = re(e, s) : e && (n[s] = String(e)), n;
}, {}), H = (r, n) => () => {
  const s = "https://api.forms.saas.dev.au.rptau.net", e = ne(n ?? {}), o = J.stringify(e, { encode: !1 });
  return `${s}${r}${o ? `?${o}` : ""}`;
};
var U = { exports: {} }, C = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var oe = E, se = Symbol.for("react.element"), ae = Symbol.for("react.fragment"), ce = Object.prototype.hasOwnProperty, ie = oe.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, le = { key: !0, ref: !0, __self: !0, __source: !0 };
function Z(r, n, s) {
  var e, o = {}, i = null, u = null;
  s !== void 0 && (i = "" + s), n.key !== void 0 && (i = "" + n.key), n.ref !== void 0 && (u = n.ref);
  for (e in n) ce.call(n, e) && !le.hasOwnProperty(e) && (o[e] = n[e]);
  if (r && r.defaultProps) for (e in n = r.defaultProps, n) o[e] === void 0 && (o[e] = n[e]);
  return { $$typeof: se, type: r, key: i, ref: u, props: o, _owner: ie.current };
}
C.Fragment = ae;
C.jsx = Z;
C.jsxs = Z;
U.exports = C;
var K = U.exports;
const M = new te({
  connectClientId: "4dv8t78fhkbvgqm6bqabvq55do",
  connectOAuthUrl: "https://auth.au.dev.rc.reapit.cloud",
  connectUserPoolId: "ap-southeast-2_CvXsvquCj"
}), Q = x(M), De = ({ reapitConnectSession: r, children: n }) => /* @__PURE__ */ K.jsx(Q.Provider, { value: r, children: n }), W = () => I(Q), ue = (r, n, s, e, o, i, u) => () => {
  if (r && n) {
    const d = n.message === O, g = n.code === P;
    if (u && (d || g))
      return e("/login");
    const c = B(n, o);
    i && c && i(c), !i && c && s(c), console.error(c);
  }
}, de = (r, n, s, e) => () => {
  r && (e && s && e(s), !e && s && n(s));
}, Oe = ({
  path: r,
  errorMessage: n,
  successMessage: s,
  queryParams: e,
  headers: o = {},
  fetchWhenTrue: i,
  onSuccess: u,
  onError: d,
  retry: g,
  isProtectedRoute: c = !0,
  queryKeys: f = []
}) => {
  const { success: h, error: y } = A(), v = N(), S = X(), b = W(), F = i?.length ? i?.filter(Boolean).length === i.length : !0, D = T(H(r, e), [r, e]), { data: m, error: w, isLoading: a, isSuccess: t, isError: l, isRefetching: p, refetch: R } = Y({
    queryKey: [...f, D],
    queryFn: async () => {
      let L = o;
      if (c && (L = await j(b, o)), !L) throw new Error(O);
      return (await k.get(D, {
        headers: L
      })).data;
    },
    retry: g === void 0 ? 1 : g,
    refetchOnWindowFocus: !1,
    enabled: F
  });
  q(de(t, h, s, u), [
    t,
    s,
    u,
    h
  ]), q(ue(l, w, y, v, n, d), [
    l,
    w,
    n,
    d,
    v,
    c
  ]);
  const _ = m || null, V = w?.message ? w.message : null;
  return [_, F && a, V, R, p, () => {
    S.removeQueries({ queryKey: [D] });
  }];
}, Fe = ({
  path: r,
  method: n = "POST",
  shouldReturnRecord: s = !1,
  headers: e = {},
  errorMessage: o,
  successMessage: i,
  isProtectedRoute: u = !0
}) => {
  const { error: d, success: g } = A(), c = N(), f = T(H(r), [r]), { mutateAsync: h, data: y, isSuccess: v, isError: S, isPending: b } = ee({
    mutationKey: [f],
    mutationFn: async (m) => {
      let w = e;
      if (u && (w = await j(M, e)), !w) throw new Error(O);
      const a = await k(f, {
        method: n,
        headers: w,
        data: m
      });
      if (!s) return a?.data || !0;
      const l = a.headers.get("Location")?.valueOf();
      if (!l) throw new Error("Location was not returned by server");
      const p = l.includes(".prod.paas") ? l.replace(".prod.paas", "") : l;
      return (await k(p, {
        method: "GET",
        headers: w
      })).data;
    },
    onSuccess: () => {
      i && g(i);
    },
    onError: (m) => {
      const w = m?.message === O, a = m.code === P;
      if (u && (w || a))
        return c("/login");
      const t = w ? null : B(m, o);
      t && d(t, 5e3), console.error(t);
    }
  });
  return [(m) => h(m), b, y ?? null, v, S];
}, fe = "/api/storage/files", $ = k.create({
  baseURL: fe
}), G = x($), ke = ({ children: r }) => /* @__PURE__ */ K.jsx(G.Provider, { value: $, children: r }), pe = () => I(G), Ce = (r) => {
  const { error: n, success: s } = A(), [e, o] = E.useState(!1), i = () => {
    r?.errorMessage && n(r.errorMessage);
  }, u = () => {
    r?.successMessage && s(r.successMessage);
  }, d = pe(), g = W(), c = z(async () => {
    const a = {
      "Content-Type": "application/json"
    };
    if (r?.disableReapitConnect)
      return {
        headers: a
      };
    const t = await j(g, a);
    if (!t) throw new Error(O);
    return {
      headers: t
    };
  }, [g]), f = T(
    () => [
      {
        attributeId: "ReapitForms-Test",
        attributeValue: "true"
      }
    ],
    []
  ), h = async (a) => {
    const t = a.name, l = await c();
    return (await d.post(
      "",
      {
        fileName: t,
        archivable: !0,
        attributes: f
      },
      l
    )).data;
  }, y = async (a) => {
    const t = await d.request(a);
    if (t.status >= 200 || t.status < 300) return "success";
    throw "Failed to upload the file on s3";
  }, v = async (a) => {
    if (!a || !a?.length) throw "File can't be empty";
    o(!0);
    try {
      const t = await c(), l = await d.post(
        "/_verify",
        [
          {
            fileIds: a,
            attributes: f
          }
        ],
        t
      );
      if (o(!1), l.status >= 200 && l.status < 300)
        return u(), "success";
      throw i(), "failed to verify";
    } catch (t) {
      throw o(!1), i(), t;
    }
  }, S = async (a) => {
    if (!a) throw "File can't be empty";
    o(!0);
    try {
      const t = await h(a), l = t.links[0];
      return await y({ data: a, headers: l.headers || [], url: l.url, method: l.method }), o(!1), u(), t;
    } catch (t) {
      throw o(!1), i(), t;
    }
  }, b = async (a) => {
    if (!a) throw "File can't be empty";
    o(!0);
    try {
      const t = await c(), l = await d.get(a, t);
      return o(!1), u(), l.data;
    } catch (t) {
      throw o(!1), i(), t;
    }
  };
  return {
    isLoading: e,
    upload: S,
    getFileInformation: b,
    verifyFiles: v,
    archiveFiles: async (a) => {
      if (!a || !a.length) throw "File can't be empty";
      o(!0);
      const t = a.toString();
      if (!t) throw "File ID can't be empty";
      try {
        const l = await c(), p = await d.patch(
          `/archive/_bulk?fileIds=${t}`,
          { fileIds: t },
          l
        );
        return o(!1), u(), p.data;
      } catch (l) {
        throw o(!1), i(), l;
      }
    },
    getFileInformationBulk: async (a) => {
      if (!a || !a.length) throw "File can't be empty";
      o(!0);
      try {
        const t = await c(), l = await d.get(
          `/_bulk?fileIds=${a.toString()}`,
          t
        );
        return o(!1), u(), l.data;
      } catch (t) {
        throw o(!1), i(), t;
      }
    },
    downloadFile: async (a) => {
      o(!0);
      try {
        const t = await b(a), l = t.link?.url ?? t.links?.find((R) => R.type === "DOWNLOAD")?.url;
        if (!l) throw "Err: file not found";
        const p = document.createElement("a");
        p.href = l, p.download = t.fileName, p.style.display = "none", document.body.appendChild(p), p.click(), document.body.removeChild(p), o(!1), u();
      } catch (t) {
        throw o(!1), i(), t;
      }
    },
    downloadFileBlob: async (a) => {
      o(!0);
      try {
        const t = await b(a), l = t.link?.url ?? t.links?.find((_) => _.type === "DOWNLOAD")?.url;
        if (!l) throw new Error("Err: file not found");
        const p = await $.get(l, { responseType: "blob" }), R = new File([p.data], t.fileName);
        return o(!1), u(), R;
      } catch (t) {
        throw o(!1), i(), t;
      }
    }
  };
}, _e = () => {
  const r = E.useRef(0), [n, s] = E.useState(!1), e = E.useMemo(
    () => (c) => {
      c.preventDefault(), c.stopPropagation();
    },
    []
  );
  E.useEffect(() => (window.addEventListener("dragenter", e), window.addEventListener("dragleave", e), window.addEventListener("dragover", e), () => {
    window.removeEventListener("dragenter", e), window.removeEventListener("dragleave", e), window.removeEventListener("dragover", e);
  }), [e]);
  const o = (c) => {
    e(c), !r.current && s(!0);
  }, i = (c) => {
    e(c), !r.current && s(!1);
  }, u = (c) => (f) => {
    f.preventDefault(), f.stopPropagation(), s(!1), r.current = 0;
    let h = [];
    f.dataTransfer.items.length ? h = [...f.dataTransfer.items].reduce((y, v) => {
      const S = v.getAsFile();
      return S ? [...y, S] : y;
    }, []) : h = [...f.dataTransfer.files], c(h);
  };
  return { registerMainHandler: (c) => ({
    onDragOver: e,
    onDragEnter: o,
    onDragLeave: i,
    onDrop: u(c)
  }), childHandler: {
    onDragOver: e,
    onDragEnter: (c) => {
      e(c), r.current++;
    },
    onDragLeave: (c) => {
      e(c), r.current--;
    }
  }, isDragOverZone: n };
};
function Le(r, n) {
  const s = E.useRef(null);
  return [(i) => {
    if (n?.startImmediatly && s.current === null) {
      r(i);
      return;
    }
    s.current && (clearTimeout(s.current), s.current = null), s.current = setTimeout(() => {
      r(i);
    }, n?.delay ?? 500);
  }, () => s.current && clearTimeout(s.current)];
}
export {
  P as NETWORK_ERROR,
  O as RC_SESSION_MISSING_ERROR,
  De as ReapitConnectSessionProvider,
  ke as StorageProvider,
  j as getMergedHeaders,
  H as getUrl,
  ue as handleError,
  B as handleReapitError,
  de as handleSuccess,
  ne as objectToQuery,
  M as reapitConnectBrowserSession,
  re as stringListToBatchQuery,
  Ce as useAttachment,
  Le as useDebounce,
  _e as useDragAndDrop,
  Oe as usePlatformGet,
  Fe as usePlatformUpdate,
  W as useReapitConnectSession,
  pe as useStorageApi
};
